import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { hideSnackbar } from "./actions";
import "./style.css";

const classes = {
  success: {
    background: "#5c915a",
    color: "white",
  },
  error: {
    background: "#a85050",
    color: "white",
  },
};

const Snackbar = ({ snackbar, hideSnackbar }) => {
  const timerRef = useRef(null);
  const snackbarRef = useRef(null);

  useEffect(() => {
    if (snackbar?.open) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      if (snackbarRef.current) {
        document.body.style.marginBottom = snackbarRef.current.offsetHeight + "px";
      }

      const delay = snackbar.delay || 3000;
      const onStart = snackbar.onStart;
      const onEnd = snackbar.onEnd;

      if (onStart) {
        onStart();
      }

      timerRef.current = setTimeout(() => {
        hideSnackbar();
        document.body.style.marginBottom = 0;
        if (onEnd) {
          onEnd();
        }
        timerRef.current = null;
      }, delay);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [snackbar, hideSnackbar]);

  const { label = "", type = "", open = false, button = null } = snackbar || {};

  const className =
    "snackbar " + (type ? type : "") + (open === true ? " show" : "");

  if (!open) return null;

  return (
    <React.Fragment>
      <div ref={snackbarRef} className={className} style={classes[type] || {}}>
        <div>{label}</div>
        {button && (
          <button onClick={button.onClick} to={button.to} type={button.type}>
            {button.label}
          </button>
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  snackbar: state.snackbar,
});

export default connect(mapStateToProps, { hideSnackbar })(Snackbar);
